module.exports = __webpack_public_path__ + "img/20210420_122223.56e3ce15.jpg";